<template>
    <div v-show="this.show" class="uk-container uk-container-center uk-text-center uk-align-center">
        <div v-if="this.empty" class="uk-alert-warning uk-width-3-4 uk-align-center " uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p>{{this.$store.getters.GetText.reports.empty[this.$store.getters.Lang]}}</p>
        </div>
        <div v-if="this.$store.getters.Lang=='En'">
            <div  class=" uk-border-rounded uk-card uk-card-default uk-card-body uk-width-2-3@m uk-margin uk-animation-scale-down uk-align-center uk-text-left" v-for="report in this.reports" v-bind:key="report.id">
                <!-- Notifications -->
                <div v-if="report.notifications && report.notifications.length" title="Замечания будут скрыты после проверки." >
                    <div v-for="notification in report.notifications" :key="notification.id">
                        <div  class="uk-alert uk-align-center" v-bind:class="'uk-alert'+'-'+notification.level">                            
                            <p  class="uk-text-bolder uk-text-center">{{notification.title_ru}}</p>
                            <p >{{notification.anatations_ru}}</p>
                        </div>
                    </div>                    
                </div>
                <div class="uk-card-badge uk-label">{{ this.status_list['Ru'][report.status]}}</div>                
                <h4>{{report.title_ru}}</h4>
                
                <h5 class="uk-text-italic">{{report.author_ru}}</h5>   
                <p v-if="report.co_author_ru" class="uk-article-meta uk-text-italic">{{report.co_author_ru}}</p>
                <hr>
                <div class="uk-height-max-medium uk-overflow-auto">
                    <p class="uk-text-justify" v-html="report.annotation_ru"></p>
                </div>                
            
                <hr>
                <!-- Files -->
                <div class="uk-text-left uk-width-1-2@m">                    
                    <div>
                        <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract[this.$store.getters.Lang]}}:</label><br>
                        <ul>
                        <li v-if="report.file_ru">
                            <a  :href="report.file_ru.url"  title="Download">{{report.file_ru.name}}</a>
                        </li>                            
                        <li v-if="report.file_en" >
                            <a :href="report.file_en.url"  title="Download">{{report.file_en.name}}</a>
                            </li>
                        </ul>                                      
                    </div>
                    
                    <div v-if="report.file_oth && report.file_oth.length">
                        <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract_oth[this.$store.getters.Lang]}}:</label>                        
                        <ul>
                          <li v-for="file in report.file_oth" :key="file.id">
                            <a :href="file.url" target="_blank">{{ file.name }}</a>
                          </li>
                        </ul>
                    </div>                    
                </div>
                <!-- Buttons -->
                <div v-if="this.$store.getters.GetBlock.reports" class="uk-text-center">
                    <a class="uk-button" uk-icon="icon: pencil; ratio: 2" v-on:click="edit(report.id)"   title="Edit"></a>
                    <a class="uk-button" uk-icon="icon: trash; ratio: 2" v-on:click="remove(report.id)" title="Remove"></a>
                </div>
                
                       
            </div>
        </div>
        <div v-else>
            <div  class=" uk-border-rounded uk-card uk-card-default uk-card-body uk-width-2-3@m uk-margin uk-animation-scale-down uk-align-center uk-text-left" v-for="report in this.reports" v-bind:key="report.id">
                <div v-if="report.notifications && report.notifications.length" title="Замечания будут скрыты после проверки." >
                    <div v-for="notification in report.notifications" :key="notification.id">
                        <div  class="uk-alert uk-align-center" v-bind:class="'uk-alert'+'-'+notification.level">                            
                            <p  class="uk-text-bolder uk-text-center">{{notification.title_en}}</p>
                            <p >{{notification.anatations_en}}</p>
                        </div>
                    </div>                    
                </div>
                <div class="uk-card-badge uk-label">{{ this.status_list['En'][report.status]}}</div>
                <h4 >{{report.title_en}}</h4>
                <h5 class="uk-text-italic">{{report.author_en}}</h5>   
                <p v-if="report.co_author_en" class="uk-article-meta uk-text-italic">{{report.co_author_en}}</p>
                <hr>
                <div class="uk-height-max-medium uk-overflow-auto">
                   <p class="uk-text-justify" v-html="report.annotation_en"></p> 
                </div>
                <hr>
                <!-- Files -->
                <div class="uk-text-left uk-width-1-2@m">                    
                    <div>
                        <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract[this.$store.getters.Lang]}}:</label><br>
                        <ul>
                        <li v-if="report.file_ru">
                            <a  :href="report.file_ru.url"  title="Download">{{report.file_ru.name}}</a>
                        </li>                            
                        <li v-if="report.file_en" >
                            <a :href="report.file_en.url"  title="Download">{{report.file_en.name}}</a>
                            </li>
                        </ul>                                      
                    </div>
                    <div v-if="report.file_oth && report.file_oth.length">
                        <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract_oth[this.$store.getters.Lang]}}:</label>                        
                        <ul>
                          <li v-for="file in report.file_oth" :key="file.id">
                            <a :href="file.url" target="_blank">{{ file.name }}</a>
                          </li>
                        </ul>
                    </div>                    
                </div>
                <!-- Buttons -->
                <div v-if="this.$store.getters.GetBlock.reports" class="uk-text-center">
                    <a class="uk-button" uk-icon="icon: pencil; ratio: 2" v-on:click="edit(report.id)"   title="Edit"></a>
                    <a class="uk-button" uk-icon="icon: trash; ratio: 2" v-on:click="remove(report.id)" title="Remove"></a>
                </div>
            </div>
        </div>

    <!-- Edit Modal -->
    <div class="uk-flex-top modal-edit uk-position-z-index uk-margin-top" uk-modal>
        <div class="uk-border-rounded uk-modal-dialog uk-margin-auto-vertical uk-width-2-3@m uk-margin uk-align-center">
            <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-child-width-expand@s uk-text-center uk-margin-top" uk-grid>
                <!-- RU -->
                
                <div class="uk-margin-small-left uk-margin-small-right">
                <h4>{{ this.$store.getters.GetText.reports.add_title1[this.$store.getters.Lang]}}</h4>    
                <!-- Title -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.rep_title[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="titleRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon">
                    </div>
                </div>
                <!-- Author -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.author[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="authorRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.author_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div>
                <!-- Co-Author -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.coauthor[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">                    
                    <input v-model="coauthorRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.coauthor_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div> 
                <!-- Anotation -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.annotation[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <textarea  v-model="annotationRu" class="uk-textarea" rows="5" v-bind:placeholder="this.$store.getters.GetText.reports.text[this.$store.getters.Lang]" maxlength="2000"></textarea>
                    </div>
                </div> 


                </div>                
                <!-- En -->
                
                <div class="uk-margin-small-left uk-margin-small-right">
                <h4>{{ this.$store.getters.GetText.reports.add_title2[this.$store.getters.Lang]}}</h4>
                <!-- Title -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.rep_title[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="titleEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon">
                    </div>
                </div> 
                <!-- Author -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.author[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="authorEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.author_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div> 
                <!-- Co-Author -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.coauthor[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="coauthorEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.coauthor_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div>
                <!-- Anotation -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.annotation[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">                    
                    <textarea v-model="annotationEn"  class="uk-textarea" rows="5" v-bind:placeholder="this.$store.getters.GetText.reports.text[this.$store.getters.Lang]" maxlength="2000"></textarea>
                    </div>
                </div> 
               
            </div>    
              
                
            </div>
            <!-- Dropzone -->
                <!-- Abstract -->
                <div v-if="this.$store.getters.GetBlock.anotations_files" class="uk-margin uk-margin-small-left uk-margin-small-right">                    
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                        <div class="uk-placeholder uk-text-center uk-card uk-padding uk-background-muted uk-margin" ref="drop" v-html="this.$store.getters.GetText.reports.upload[this.$store.getters.Lang]"></div>                        
                    </div>
                    <p v-html="this.$store.getters.GetText.reports.abstract_not[this.$store.getters.Lang]"></p>
                </div>
                <!-- Abstract_oth -->
                <div v-if="this.$store.getters.GetBlock.anotations_other" class="uk-margin uk-margin-small-left uk-margin-small-right">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract_oth[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                        <div class="uk-placeholder uk-text-center uk-card uk-padding uk-background-muted uk-margin" ref="dropOther" v-html="this.$store.getters.GetText.reports.upload[this.$store.getters.Lang]"></div>
                        <p v-html="this.$store.getters.GetText.reports.abstract_oth_not[this.$store.getters.Lang]"></p>
                    </div>
                </div>
            <!--button class="uk-button uk-button-primary uk-width-medium" v-on:click="this.clearFile()">{{ this.$store.getters.GetText.reports.clear_file[this.$store.getters.Lang] }}</button-->
            <button class="uk-button uk-button-primary  uk-width-expand uk-width-1-3 uk-align-center" v-on:click="update()" >{{this.$store.getters.GetText.personal.save[this.$store.getters.Lang]}}</button>
            <button class="uk-button uk-button-danger  uk-width-expand uk-width-1-3 uk-align-center" v-on:click="cancel()">{{this.$store.getters.GetText.personal.cancel[this.$store.getters.Lang]}}</button>
            </div>  
    </div>

    </div>
    
</template>

<script>
import api from '@/api'
import UIkit from 'uikit'
import dropzone from 'dropzone'
import axios from 'axios'
import router from '@/router'


export default {
    data(){
        return{            
            authorId:this.$store.getters.User.id,
            show: false,
            empty: true,
            reports:[],
            drop:'',
            dropOther:'',
            titleRu:'',
            titleEn:'',
            authorRu:'',
            authorEn:'',
            coauthorRu:'',
            coauthorEn:'',
            annotationRu:'',
            annotationEn:'',
            abstractId:'',
            abstractRu:null,
            abstractEn:null,
            abstractOth:null,
            abstractsForRemove:[],

            status_list:{
                Ru:{1:'Ревью',2:'Подтверждён',3:'Ожидает оплаты',4:'Требует изменений',5:'Опубликовано',6:'Отклонено',7:'В архиве'},
                En:{1:'Review',2:'Accepted',3:'Awaiting payment',4:'Requires change',5:'Published',6:'Rejected',7:'Archived'}
            }
        }
    },


    mounted(){        
        var $this=this
        axios.post('api/auth/refresh', {}, {
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    'X-Header-token-api': "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
                }
            }).then(response => {
                localStorage.setItem('access_token', response.data.access_token)               
                $this.load()                
            }).catch(function() {
                router.push({ name: 'login' })
                localStorage.removeItem('access_token')
            });
        this.load()
        },
    methods:{
        load(){
            var $this=this
            api.post('api/auth/abstract/get',{
            'author_id':this.authorId
            }).then(res=>{            
            if (typeof(res.data)==='object'){                
                $this.show=true
                //console.log(res.data)
                $this.reports=res.data                
                if (Object.keys(res.data).length>0){
                    $this.empty=false;
                    //console.log(Object.keys(res.data).length)
                } else {
                    $this.empty=true;
                }
                return true
                } else {
                    //console.log(res.data)                
                    return false
                }            
            //
            }).catch(error=>{
                error
            })
        },

        remove(id){
            var $this =this
            UIkit.modal.confirm(this.$store.getters.GetText.reports.confirm_remove[this.$store.getters.Lang]).then(function() {                 
                api.post("api/auth/abstract/delete",{id: id}).then(res=>{
                    res
                    $this.$router.go()   
                    //console.log(res)                                     
                }).catch(error=>{
                    error
                    //console.log(error.data)
                })
            });
            
        },
        get_publication(id) {
            for (let i = 0; i < this.reports.length; i++) {
                if (this.reports[i].id === id) {
                    this.abstractId=id                                        
                    this.titleRu=this.reports[i].title_ru
                    this.titleEn=this.reports[i].title_en
                    this.authorRu=this.reports[i].author_ru
                    this.authorEn=this.reports[i].author_en
                    this.coauthorRu=this.reports[i].co_author_ru
                    this.coauthorEn=this.reports[i].co_author_en
                    this.annotationRu=this.reports[i].annotation_ru
                    this.annotationEn=this.reports[i].annotation_en
                    this.abstractRu=this.reports[i].file_ru
                    this.abstractEn=this.reports[i].file_en
                    this.abstractOth=this.reports[i].file_oth
                    return true
                }
            }
            return false; // if no publication with given ID is found
        },
        edit(id){            
            this.abstractsForRemove=[]
            this.titleRu=''
            this.titleEn=''
            this.authorRu=''
            this.authorEn=''
            this.coauthorRu=''
            this.coauthorEn=''
            this.annotationRu=''
            this.annotationEn=''
            this.abstractRu=null
            this.abstractEn=null
            this.abstractOth=null    
            this.get_publication(id)  
            if (this.$store.getters.GetBlock.anotations_files){
                if (this.drop){
                    this.drop.destroy()                               
                    this.$refs.drop.innerHTML = this.$store.getters.GetText.reports.upload[this.$store.getters.Lang];                  
                }             
                          
                this.initDrop()

                if (this.abstractRu){
                    let mockFile = { id:this.abstractRu.id, name: this.abstractRu.name };
                    this.drop.displayExistingFile(mockFile, this.abstractRu.url);
                }
                if (this.abstractEn) {
                    let mockFile = { id:this.abstractEn.id ,name: this.abstractEn.name  };
                    this.drop.displayExistingFile(mockFile, this.abstractEn.url);
                }
                this.drop.createImageThumbnails=false    
            
            }
            //console.log(this.abstractOth)
            if (this.$store.getters.GetBlock.anotations_other){
                if (this.dropOther){
                    this.dropOther.destroy()                               
                    this.$refs.dropOther.innerHTML = this.$store.getters.GetText.reports.upload[this.$store.getters.Lang];                  
                }             
                this.initDropOther()
                if (this.abstractOth && this.abstractOth.length){
                    this.abstractOth.forEach((file)=>{
                        //console.log(file)
                        let mockFile = {id: file.id ,name: file.name  };
                        this.dropOther.displayExistingFile(mockFile, file.url);
                    })
                }
                this.dropOther.createImageThumbnails=false  
                              
            }

            
           
            
            UIkit.modal(document.getElementsByClassName('modal-edit')).show();
        },
        update(){
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            var abstracts= new FormData()
            var abs={}
            var oth ={}
            if (this.$store.getters.GetBlock.anotations_files){
                abs = this.drop.getAcceptedFiles()                
                if (this.$store.getters.GetBlock.anotations_other){
                    oth = this.dropOther.getAcceptedFiles()
                }                
            } else if (this.$store.getters.GetBlock.anotations_other){
                oth = this.dropOther.getAcceptedFiles()
            }
            const files = Object.assign(abs,oth)
            if (files){
                files.forEach(file=>{                
                    abstracts.append('abstracts[]',file)
                })
            }
            abstracts.append('id',this.abstractId)
            abstracts.append('title_ru',this.titleRu)
            abstracts.append('title_en',this.titleEn)
            abstracts.append('author_id',this.authorId)
            abstracts.append('author_ru',this.authorRu)
            abstracts.append('author_en',this.authorEn)
            abstracts.append('co_author_ru',this.coauthorRu)
            abstracts.append('co_author_en',this.coauthorEn)
            abstracts.append('annotation_ru',this.annotationRu)
            abstracts.append('annotation_en',this.annotationEn)
            this.abstractsForRemove.forEach(idfordelete=>{
                abstracts.append('removed[]',Number(idfordelete))
            })
            
            abstracts.append('_method','PATCH')
            
            api.post("api/auth/abstract/update",abstracts,config).then(res=>{
                    res    
                    //console.log(res)
                    this.$router.go()                    
                }).catch(error=>{
                    error
                    //console.log(error.data)
                })


            UIkit.modal(document.getElementsByClassName('modal-edit')).hide();
        },
        cancel(){
            UIkit.modal(document.getElementsByClassName('modal-edit')).hide();
        },
        initDrop(){            
            this.drop = new dropzone(this.$refs.drop,{
                    url: "/",
                    maxFilesize: 20,
                    maxFiles: 2,
                    autoProcessQueue: false,
                    createImageThumbnails: false,
                    maxThumbnailFilesize: 2,
                    acceptedFiles: '.pdf,.doc,.docx',
                    addRemoveLinks: true,
                    
                    accept: function(file, done) {                            
                            //const isInclude = file.som(name=> name=== file.name)  // уже есть ?
                            if ((file.name.toLowerCase().indexOf('_en.')==-1)&&(file.name.toLowerCase().indexOf('_ru.')==-1)){
                                done('Does not match naming pattern "_ru.*" or "_en.*"'); //  отклоняем попытку добавить
                            }                                
                            else {
                                //filles.push(file.name); // сохраняем имя файла
                                done();  // все ок. 
                                } 
                            }                   
            })
            this.drop.on('removedfile',(file)=>{
                 this.abstractsForRemove.push(file.id)
                //console.log(this.abstractsForRemove)
            })
        },
        initDropOther(){            
            this.dropOther = new dropzone(this.$refs.dropOther,{
                    url: "/",
                    maxFilesize: 50,                    
                    autoProcessQueue: false,
                    createImageThumbnails: false,
                    maxThumbnailFilesize: 2,
                    acceptedFiles: '*.zip,.pdf,.doc,.docx',
                    addRemoveLinks: true,
                    
                    accept: function(file, done) {                            
                            //const isInclude = file.som(name=> name=== file.name)  // уже есть ?
                            if ((file.name.toLowerCase().indexOf('_expert.')==-1)&&(file.name.toLowerCase().indexOf('_export.')==-1)){
                                done('Does not match naming pattern "*_expert.*" or "*_export.*"'); //  отклоняем попытку добавить
                                done();
                            }                                
                            else {
                                //filles.push(file.name); // сохраняем имя файла
                                done();  // все ок. 
                                } 
                            }                   
            })
            this.dropOther.on('removedfile',(file)=>{
                 this.abstractsForRemove.push(file.id)
                //console.log(this.abstractsForRemove)
            })
        }


    }

}
</script>
<style>
.dz-success-mark,
.dz-error-mark,
.dz-size,
.dz-image{
    display:none;
    }

</style>


<style scoped>
    .uk-card{
       box-shadow: 10px 5px 5px rgb(236, 231, 231);
    }
    .uk-switch {
  position: relative;
  display: inline-block;
  height: 34px;
  width: 60px;
}

/* Hide default HTML checkbox */
.uk-switch input {
  display:none;
}
/* Slider */
.uk-switch-slider {
  background-color: rgba(0,0,0,0.22);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 500px;
  bottom: 0;
  cursor: pointer;
  transition-property: background-color;
	transition-duration: .2s;
  box-shadow: inset 0 0 2px rgba(0,0,0,0.07);
}
/* Switch pointer */
.uk-switch-slider:before {
  content: '';
  background-color: #fff;
  position: absolute;
  width: 30px;
  height: 30px;
  left: 2px;
  bottom: 2px;
  border-radius: 50%;
  transition-property: transform, box-shadow;
	transition-duration: .2s;
}
/* Slider active color */
input:checked + .uk-switch-slider {
  background-color: #39f !important;
}
/* Pointer active animation */
input:checked + .uk-switch-slider:before {
  transform: translateX(26px);
}

/* Modifiers */
.uk-switch-slider.uk-switch-on-off {
  background-color: #f0506e;
}
input:checked + .uk-switch-slider.uk-switch-on-off {
  background-color: #32d296 !important;
}

/* Style Modifier */
.uk-switch-slider.uk-switch-big:before {
  transform: scale(1.2);
  box-shadow: 0 0 6px rgba(0,0,0,0.22);
}
.uk-switch-slider.uk-switch-small:before {
  box-shadow: 0 0 6px rgba(0,0,0,0.22);
}
input:checked + .uk-switch-slider.uk-switch-big:before {
  transform: translateX(26px) scale(1.2);
}

/* Inverse Modifier - affects only default */
.uk-light .uk-switch-slider:not(.uk-switch-on-off) {
  background-color: rgba(255,255,255,0.22);
}





</style>